import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { AdminService } from "../services/admin-service";
import { NotifyService } from "../services/notify-service";
import { EntityConfigService } from "../services/entity-config-service";

export function RLListOfValuesHierarchyCSVExport() {
	var directive: ng.IDirective = {
		template: `<a class="btn btn-link btn-info" ng-click="lovheVM.Click($event)" rl-busy-button="" title="Export"><i class="fa fa-download"></i></a>`,
		bindToController: true,
		controllerAs: "lovheVM",
		controller: RLListOfValuesHierarchyCSVExportController,
		scope: {
			charValueSetID: "=charValueSetId",
			charValueSourceID: "=charValueSourceId",
			listTitle: "=listTitle"
		}
	};
	return directive;
}

class RLListOfValuesHierarchyCSVExportController {
	static $inject = ["$scope", "$timeout", "$interval", "$window", "adminService", "notifyService", "entityConfigService"];

	charValueSetID: string;
	charValueSourceID: string;
	listTitle: string;
	downloadUrl: string;
	jobID: string;
	jobTitle: string;
	showJobProgressStatus: boolean;
	progressIntervalPromise: ng.IPromise<any>;

	constructor(private $scope: ng.IScope, private $timeout: ng.ITimeoutService, private $interval: ng.IIntervalService, private $window: ng.IWindowService, private adminService: AdminService, private notifyService: NotifyService, private entityConfigService: EntityConfigService) {
		this.jobTitle = "Export";
		this.showJobProgressStatus = false;
	}

	Click($event: ng.IAngularEvent) {
		this.notifyService.startProgress();

		this.entityConfigService.exportListOfValuesHierarchyToCSV(this.charValueSetID, this.charValueSourceID, this.listTitle)
			.then((results) => {
				this.jobID = results.jobID;
				this.showJobProgressStatus = true;
				this.StartProgress();
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	StartProgress() {
		this.notifyService.startProgress();
		this.progressIntervalPromise = this.$interval(() => this.UpdateProgress(), 2000);
	}

	UpdateProgress() {
		this.adminService.getJobState(this.jobID).then((result) => {
			if (result.status == "Done" || result.status == "Failed" || result.status == "Cancelled") {
				this.$interval.cancel(this.progressIntervalPromise);
				if (result.status == "Done") {
					this.$window.location.assign(result.resultMessage);
				}
				this.notifyService.endProgress();
			}
		});
	}
}